import { useState } from "react";

const useAppState = () => {
  const [language, setLanguage] = useState("en");
  const initialStateInsured = {
    name: "",
    mobile: "",
    nricPassport: "",
    policyNo: "",
    email: "",
    addState: ""
  };
  const initialStateNominee = {
    nomineeName: "",
    nomineeNRIC: "",
    relationship: "",
    percentage: "",
    nomineePhone: "",
    nomineeDOB: "",
    nomineeEmail: "",
    isNRIC: false,
  };
  const [nomineeCount, setNomineeCount] = useState(1);
  const [insured, setInsured] = useState(initialStateInsured);
  const [nominee, setNominee] = useState(initialStateNominee);
  const [nominees, setNominees] = useState([]);
  const [declation1Checked, setDeclation1Checked] = useState(false);
  const [declation2Checked, setDeclation2Checked] = useState(false);
  const [declation3Checked, setDeclation3Checked] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [showMaintenance, setShowMaintenance] = useState({
    title: "",
    message: "",
  });
  const [product, setProduct] = useState("")

  return {
    initialStateInsured,
    insured,
    setInsured,
    nominee,
    setNominee,
    nominees,
    setNominees,
    language,
    setLanguage,
    declation1Checked,
    declation2Checked,
    declation3Checked,
    setDeclation1Checked,
    setDeclation2Checked,
    setDeclation3Checked,
    nomineeCount,
    setNomineeCount,
    isSuccess,
    setIsSuccess,
    showMaintenance,
    setShowMaintenance,
    product,
    setProduct
  };
};
export default useAppState;
